import { rem } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

export const Container = styled.label`
  display: inline-block;

  padding-left: 8px;
  margin-bottom: 4px;

  font-weight: 600;
  font-size: ${rem("10px")};
  color: ${themes.text.lower};
  font-family: ${themes.fonts.text};

  ${media.greaterThan("huge")`
    margin-bottom: 6px;

    font-size: ${rem("12px")};
  `}
`;
